export const getClockCardEntryTypes = {
  url: '/kjarni/api/v2/ClockCardEntryTypes',
  method: 'GET',
};
export const getXapValue = val => ({
  url: '/kjarni/api/v2/XapValues',
  method: 'GET',
  params: {
    $filter: `XapValueName eq '${val}'`,
  },
});
export const getWorkingHours = detailId => ({
  url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
  method: 'GET',
  params: {
    $filter: `EmployeeDetailID eq ${detailId}`,
  },
});
export const getWorkingHoursToday = detailId => ({
  url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
  method: 'GET',
  params: {
    $filter: `EmployeeDetailID eq ${detailId} and Begda le ${new Date().toISOString()} and ${new Date().toISOString()} le Endda`,
  },
});
export const getEntries = (start, end, empId) => ({
  url: '/kjarni/api/v2/ClockCardEntries',
  method: 'GET',
  params: {
    $filter: `(ClockIn ge ${start.toISOString()} and ClockIn le ${end.toISOString()}) and EmployeeDetailID eq ${empId}`,
  },
});

export const patch = (entry, entryId) => ({
  url: `/kjarni/api/v2/ClockCardEntries(${entryId})`,
  method: 'PATCH',
  data: entry,
});

export const post = entry => ({
  url: '/kjarni/api/v2/ClockCardEntries',
  method: 'POST',
  data: entry,
});

export const deleteClockCardEntry = entryId => ({
  url: `/kjarni/api/v2/ClockCardEntries(${entryId})`,
  method: 'DELETE',
});

export const getOpenEntry = detailId => ({
  url: '/kjarni/api/v2/ClockCardEntries',
  method: 'GET',
  params: {
    $filter: `EmployeeDetailID eq ${detailId} and ClockOut eq null and ClockTimeHasError eq false`,
  },
});

export const punch = (detailId, kioskId) => ({
  url: `/kjarni/api/v2/ClockCardEntries/ClockInOutDetailID(detailId=${detailId},kioskId=${kioskId})`,
  method: 'GET',
});

export const notifyEntryTypeRule = (detailId, rule, from, to) => ({
  url: `/kjarni/api/v2/ClockCardEntries/NotifyFromClockCardEntryTypeRule(detailId=${detailId},rule='${rule}',dateFrom=${from},dateTo=${to})`,
  method: 'GET',
});

export const getHolidayStatus = (payYear, masterId) => ({
  url: `/kjarni/api/v2/ClockCardEntries/Status(paywagecollectyear=${payYear},employeemasterid=${masterId})`,
  method: 'GET',
});



// WEBPACK FOOTER //
// ./src/sites/time/api.js